// Custom javascript with functions needed on Products page

function registerKlaviyoBisNotif(variantId, userEmail) {
    const reqUrl = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UwGeRa';
    const data = {
        type: 'back-in-stock-subscription',
        attributes: {
            channels: ["EMAIL"],
            profile: {
                data: {
                    type: 'profile',
                    attributes: {
                        email: userEmail
                    }
                }
            }
        },
        relationships: {
            variant: {
                data: {
                    type: 'catalog-variant',
                    id: '$shopify:::$default:::' + variantId
                }
            }
        }
    };
    const options = {
        method: 'POST',
        headers: {
            accept: 'application/json',
            revision: '2024-02-15',
            'content-type': 'application/json'
        },
        body: JSON.stringify({ data: data })
    };

    return fetch(reqUrl, options);
}

/**
 * Handles Back-in-Stock subscription flow
 */

const showBisButtonForTypes = ['16T30D', 'O30D', '8T15D'];
const showBisMessageForTypes = ['U7D', '8T15D', '16T30D', 'O30D'];

const njBisNotifBtn = document.querySelector("#nj-bis-notif-button");
const njBisForm = document.querySelector("#nj-bis-form");
const njBisFrame = document.querySelector("#nj-bis-frame");

// We might need to hide/show Inventory quantity in our BiS flow
const inventoryInfoElm = document.querySelector('.product-info__inventory');
const backorderMsgElm = document.querySelector('.display_backorder_msg p');

// Show BiS popup on button click
njBisNotifBtn.addEventListener('click', function () {
    njBisFrame.style.display = "block";
});

// Send API call to Klaviyo on form submission
const njBisRegistCompleted = njBisForm.querySelector("#completed_message");
const njBisRegistFailed = njBisForm.querySelector("#error_message");
njBisForm.addEventListener('submit', function (event) {
    event.preventDefault();

    let requestHandler = registerKlaviyoBisNotif(njBisForm['product-variant-id'].value, njBisForm['email'].value);
    requestHandler.then(response => {
        if (response.ok) {
            njBisRegistCompleted.style.display = "block";
        } else {
            njBisRegistFailed.style.display = "block";
        }
    }).catch(err => {
        njBisRegistFailed.style.display = "block";
    });
});

// Dismiss popup on click on any elements with 'nj-bis-close' class
const njBisBody = document.querySelector("#nj-bis-body");
njBisBody.addEventListener("click", function (event) {
    if (event.target.classList.contains('nj-bis-close')) {
        njBisFrame.style.display = "none";
        event.stopPropagation();
    }
});

// Show BiS notification subscription button based on the variant's backorder type
function onProductVariantChange(variantId) {
    // Reset the state back when switching to variants with available stock
    njBisNotifBtn.style.display = "none";
    inventoryInfoElm.style.display = "block";
    backorderMsgElm.innerHTML = "";

    // Handled in liquid, product with inventory available won't have this component
    let backorderMessages = document.querySelector('.backorder_msgs [var_id="' + variantId + '"]');
    if (backorderMessages) {
        let backorderMsg = backorderMessages.getAttribute('backorder_msg') || '';
        let productTags = backorderMessages.getAttribute('nj_tags').split(',');
        productTags.forEach(tag => {
            if (showBisButtonForTypes.includes(tag)) {
                njBisForm['product-variant-id'].value = variantId;
                njBisNotifBtn.style.display = "block";
            }

            // Legacy: Show backorder message if their type is not set, or they're in the specified list of types
            if (!tag || showBisMessageForTypes.includes(tag)) {
                backorderMsgElm.innerHTML = backorderMsg;
                inventoryInfoElm.style.display = "none";
            }
        })
    }
}

// Impact theme custom event: when user is changing the selected product variant.
// https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
document.addEventListener('variant:change', (event) => { onProductVariantChange(event.detail.variant.id) });

// Show the button on first page load
onProductVariantChange(njBisForm['product-variant-id'].value);


// Number of section in the 'Shop the Room' area
const SR_SECTION_COUNT = 3;

// Show/hide 'Shop the Room' area based on on custom.shop_the_look flag
function hideShopTheRoomElements(event) {
    const sections = document.getElementsByTagName('section');
    for (let sectionIdx = 0; sectionIdx < sections.length; sectionIdx++) {
        const element = sections[sectionIdx];
        let srHeaderEl = false;
        for (let pEl of element.querySelectorAll('p')) {
            if (pEl.textContent === "Shop the Room") {
                srHeaderEl = pEl;
            }
        }
        if (!srHeaderEl) continue;

        // Not hiding entire StR header section as we still need the spacing of it. So the next section'll still look nice.
        srHeaderEl.style.display = "none";
        for (let srCompOffset = 1; srCompOffset < 3; srCompOffset++) {
            const srElement = sections[sectionIdx + srCompOffset];
            srElement.style.display = "none";
        }
        break;
    }
}

if (!window.NjProduct.sr_image) {
    document.addEventListener('DOMContentLoaded', hideShopTheRoomElements);
}

// Hide Review.io headline if there's no UGC available
function hideReviewIoHeadline(event) {
    const rioUgcWidgets = document.getElementsByTagName('reviewsio-ugc-widget');
    for (let widgetIdx = 0; widgetIdx < rioUgcWidgets.length; widgetIdx++) {
        const widget = rioUgcWidgets[widgetIdx];
        const widgetInner = widget.querySelector('.MediaGalleryWidget__inner');

        const rioUgcSection = widget.closest('section');
        const ugcHeadlineSection = rioUgcSection.previousSibling;
        if (widgetInner == null) {
            ugcHeadlineSection.style.display = 'none';
        } else {
            ugcHeadlineSection.style.display = 'block';
        }
    }
}

// When the UGC gets loaded, we want to show the headline again
const ugcWidgetElm = document.querySelector('section reviewsio-ugc-widget');
const ugcObserverConfig = { characterData: false, attributes: true, childList: true, subtree: true };
const ugcObserver = new MutationObserver((mutationsList, mutationObserver) => {
    hideReviewIoHeadline();
});
ugcObserver.observe(ugcWidgetElm, ugcObserverConfig);


function onProductRecommendationUpdated(mutationsList, mutationObserver) {
    for (const mutation of mutationsList) {
        // ShopPay forms rendering are closed source, so we can't customize them in the liquid
        const paymentTermsElm = mutation.target.querySelector('.associated-products shopify-payment-terms');
        if (paymentTermsElm != null) {
            // Tried using MutationObserver before, but they didn't fire off. So back to more primitive method
            setTimeout(() => {
                const prequalContainerElm = paymentTermsElm.shadowRoot.querySelector('#prequalAmountContainer');
                prequalContainerElm.style.display = 'none';
                const prequalBackupElm = paymentTermsElm.shadowRoot.querySelector('#prequalBackupCTA');
                prequalBackupElm.style.display = 'none';
            }, 600);
        }
    }
}

const productRecommendationElm = document.querySelector('main .product-info product-recommendations');
const observer = new MutationObserver(onProductRecommendationUpdated);
const observerConfig = { characterData: false, attributes: false, childList: true, subtree: false };
observer.observe(productRecommendationElm, observerConfig);
